import * as React from "react";

import * as releaseAdmin from "../../../../sdk/release-admin";
import { DetailContainer } from "../common/detail-container";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { ReleaseNote } from "../../../../../../../services/release-admin/types/release-note";
import { useHistory } from "react-router";
import Back from "../../../../components/basics/icons/back";
import styled from "styled-components";
import { Input, CircularProgress } from "@material-ui/core";
import TrashIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";

interface ReleaseDetailNotesProps {
  notes: ReleaseNote[];
  onNewNote: (entry: string) => void;
  loading: boolean;
  setNotes: React.Dispatch<ReleaseNote[]>;
}

export const ReleaseDetailNotes: React.FC<ReleaseDetailNotesProps> = (
  props
) => {
  const { setNotes } = props;
  const history = useHistory();
  const [note, setNote] = React.useState("");
  const [noteArray, setNoteArray] = React.useState<any>({});
  const [noteEdit, setNoteEdit] = React.useState<any>({});
  const [noteEditLoading, setNoteEditLoading] = React.useState<any>({});

  const sendNewNote = () => {
    props.onNewNote(note);
    setNote("");
  };

  const updateNote = async (note: ReleaseNote, entry: string) => {
    setNoteEditLoading({
      ...noteEditLoading,
      [entry]: true,
    });
    const response = await releaseAdmin.updateNote(note, noteArray[entry]);
    const updated = [
      ...props.notes.map((noteFilter) => {
        if (noteFilter.created_at === note.created_at) {
          return response;
        } else {
          return noteFilter;
        }
      }),
    ];
    if (response) {
      setNotes(updated);
      setNoteEditLoading({
        ...noteEditLoading,
        [entry]: false,
      });
    }
    setNoteEdit({
      ...noteEdit,
      [entry]: !noteEdit[entry],
    });
  };

  const deleteNote = async (
    releaseId: string,
    userId: string,
    created_at: Date,
    entry: string
  ) => {
    setNoteEditLoading({
      ...noteEditLoading,
      [entry]: true,
    });
    const response = await releaseAdmin.deleteNote(
      releaseId,
      userId,
      created_at as Date
    );
    if (response) {
      setNotes(props.notes.filter((note) => note.created_at !== created_at));
      setNoteEditLoading({
        ...noteEditLoading,
        [entry]: false,
      });
    }
  };

  const goBack = () => {
    history.goBack();
  };
  return (
    <DetailContainer>
      <IconWrapper>
        <Back onClick={goBack} />
      </IconWrapper>
      <TextField
        label="New note..."
        multiline
        fullWidth
        rows={6}
        value={note}
        onChange={(ev) => setNote(ev.target.value || "")}
        disabled={props.loading}
      />
      <Button
        disabled={props.loading || !note}
        onClick={() => sendNewNote()}
        fullWidth
        variant="contained"
        style={{ marginBottom: "1rem" }}
      >
        {props.loading ? "Saving..." : "Save"}
      </Button>
      {props.notes.map((note, i) => (
        <Accordion key={i} defaultExpanded={true}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            id={`panel-header-${i}`}
          >
            <Typography style={{ width: "150px" }}>
              {new Date(note.created_at).toDateString()}
            </Typography>
            <Typography style={{ width: "150px" }}>
              <b>From:</b>
              <br />
              {note.editorEmail || "?"}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Flex>
              {noteEdit[note.entry] ? (
                <>
                  <Input
                    placeholder="notes"
                    inputProps={{ "aria-label": "search" }}
                    style={{ width: "300px" }}
                    value={noteArray[note.entry]}
                    defaultValue={note.entry}
                    onChange={(event) => {
                      setNoteArray({
                        ...noteArray,
                        [note.entry]: event.target.value,
                      });
                    }}
                  />
                  <Button
                    onClick={() => updateNote(note, note.entry)}
                    style={{ marginBottom: "1rem" }}
                  >
                    {noteEditLoading[note.entry] ? "Updating..." : "Update"}
                  </Button>
                </>
              ) : (
                <Typography style={{ whiteSpace: "pre-line" }}>
                  {note.entry}
                </Typography>
              )}
              {!noteEdit[note.entry] && (
                <ButtonWrapper>
                  <EditIcon
                    onClick={() => {
                      setNoteArray({
                        ...noteArray,
                        [note.entry]: note.entry,
                      });
                      setNoteEdit({
                        ...noteEdit,
                        [note.entry]: !noteEdit[note.entry],
                      });
                    }}
                  />
                  {noteEditLoading[note.entry] ? (
                    <CircularProgress size={"24px"} />
                  ) : (
                    <TrashIcon
                      onClick={() =>
                        deleteNote(
                          note.releaseId,
                          note.userId,
                          note.created_at,
                          note.entry
                        )
                      }
                    />
                  )}
                </ButtonWrapper>
              )}
            </Flex>
          </AccordionDetails>
        </Accordion>
      ))}
    </DetailContainer>
  );
};

const IconWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const ButtonWrapper = styled.div`
  display: flex;
`;
